import { UserService } from 'src/app/_services/user.service';

import { ActivatedRoute } from '@angular/router';

import { Component, OnInit } from '@angular/core';
import { GuardianService } from 'src/app/_services/guardian.service';
import { Subscription } from '../../_models/subscription';
import { AuthService } from '../../_services/auth.service';
import { StudentService } from '../../_services/student.service';


@Component({
  selector: 'app-pending-quiz-show-pending',
  templateUrl: './pending-quiz-show.component.html',
  styleUrls: ['./pending-quiz-show.component.css']
})
export class PendingQuizShow implements OnInit {
  guardian = undefined
  server_student_user_id=0
  server_enrolment_id=0
  data: any={}
  subscription = new Subscription()
  subscriptionId = 0
  hasEnrollments = false
  isPremium= false
  loadingEnvelops=false
  loading_learner=false

  imageSource:any
  allQuizCount = 0
  showQuizItems = false
  learner=undefined
  maskedGift=undefined
  quiz_mode_name=""
  dtOptions: DataTables.Settings={}
  constructor(
    public authService: AuthService,
    public userService: UserService,
    private guardianService:GuardianService,
    private studentService: StudentService,
    private activatedRoute:ActivatedRoute,) { }

  ngOnInit(): void {

    this.dtOptions = {paging: false,ordering: false,info: false}
    this.initParams()
  }
  initParams(){
    this.activatedRoute.params.subscribe(
      params=>{
        this.server_student_user_id=params['server_student_user_id']
        this.quiz_mode_name = params["quiz_mode_name"]
        this.initStudent()
        this.initGifting()
      }
    )
    this.guardian= this.guardianService.guardianSubject.getValue()
  }
  initPendingQuiz(){
    this.loadingEnvelops=true
    this.studentService.getWebPendingQuiz(this.server_student_user_id,this.quiz_mode_name).subscribe(
      data => {
        if (data) {
          this.data=data

          this.loadingEnvelops=false
         }
       }
     );
  }

  initGifting(){

    this.studentService.getGiftingInformation(this.server_student_user_id).subscribe(
      giftingImage=>{
        this.maskedGift=giftingImage

      }
    )
  }
initStudent(){
  this.loading_learner=true
  this.studentService.getLearner(this.server_student_user_id).subscribe(
    learner=>{
      this.loading_learner=false
      this.learner=learner
      this.subscription=learner['subscription_object']
      this.initPendingQuiz()
    }
  )
}
 displayMode() {
  return (this.quiz_mode_name.charAt(0).toUpperCase() + this.quiz_mode_name.slice(1))+" "+ "Mode";
}

}
